// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1740":"b6ed8a73","5695":"b6ed8a73","6507":"3b53517f","6724":"3b53517f","9608":"b6ed8a73"}[chunkId] + ".chunk.css";
};